import store from "@/store";

const NETWORK_ERROR_MESSAGE_AUTHENTICATED =
  "تعذر تأكيد حالة عملية الدفع، يرجى مراجعة سجل التبرعات للتأكد من حالة العملية";

const NETWORK_ERROR_MESSAGE_NON_AUTHENTICATED =
  "جارٍ معالجة عملية الدفع، وستصلك رسالة تأكيد عند اكتمالها. لا حاجة لإعادة التبرع";

export function getNetworkErrorMessage(): string {
  return store.getters.isAuthenticated
    ? NETWORK_ERROR_MESSAGE_AUTHENTICATED
    : NETWORK_ERROR_MESSAGE_NON_AUTHENTICATED;
}
